'use strict';

export function accessibilityInit() {
  const toggleButton = document.getElementById('accessibility-title');
  if (!toggleButton) return;
  const optionsList = document.querySelector('.accessibility-options');
  const buttons = optionsList.querySelectorAll('button');

  toggleButton.addEventListener('click', () => {
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

    toggleButton.setAttribute('aria-expanded', !isExpanded);
    optionsList.setAttribute('aria-hidden', isExpanded);

    optionsList.classList.toggle('show', !isExpanded);
    toggleButton.classList.toggle('active', !isExpanded);
  });

  // Funkcja obsługująca kliknięcie poza listę
  document.addEventListener('click', event => {
    if (!event.target.closest('.accessibility-controls')) {
      toggleButton.setAttribute('aria-expanded', false);
      optionsList.setAttribute('aria-hidden', true);
      optionsList.classList.remove('show');
      toggleButton.classList.remove('active');
    }
  });

  accessibilityButtons();
}

export function outlineInit() {
  function handleFirstTab(e) {
    if (e.key === 'Tab') {
      document.body.classList.add('user-is-tabbing');
      window.removeEventListener('keydown', handleFirstTab);
      window.addEventListener('mousedown', handleMouseDownOnce);
    }
  }

  function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');
    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
  }

  window.addEventListener('keydown', handleFirstTab);
}

function accessibilityButtons() {
  const accessibilityOptions = {
    fontSizeStep: 10, // Krok zmiany czcionki w procentach
    maxFontSize: 150, // Maksymalny rozmiar czcionki w %
    minFontSize: 50, // Minimalny rozmiar czcionki w %
  };

  // Funkcja do pobrania bieżącej wartości --base-font-size z CSS
  function getBaseFontSize() {
    const baseFontSize = getComputedStyle(document.documentElement)
      .getPropertyValue('--base-font-size')
      .trim()
      .replace('%', ''); // Usuwamy znak % i zwracamy tylko liczbę
    return parseFloat(baseFontSize); // Zwracamy wartość liczbową, np. "62.5%" -> 62.5
  }

  // Funkcja do ustawiania nowej wartości --base-font-size w CSS
  function setBaseFontSize(newFontSize) {
    document.documentElement.style.setProperty(
      '--base-font-size',
      `${newFontSize}%`
    );
  }

  // Funkcja do zastosowania zmiany rozmiaru czcionki
  function applyFontSizeChange(step) {
    const currentFontSize = getBaseFontSize(); // Pobierz aktualny rozmiar czcionki
    const newFontSize = Math.max(
      accessibilityOptions.minFontSize,
      Math.min(currentFontSize + step, accessibilityOptions.maxFontSize)
    ); // Zwiększ lub zmniejsz czcionkę, z ograniczeniem do wartości min i max
    setBaseFontSize(newFontSize); // Ustaw nową wartość
  }

  // Obsługa powiększania czcionki
  document.getElementById('increase-font').addEventListener('click', () => {
    applyFontSizeChange(accessibilityOptions.fontSizeStep); // Zwiększ czcionkę o zadany krok
    saveAccessibilitySettings(); // Zapisz zmienione ustawienie czcionki
  });

  // Obsługa zmniejszania czcionki
  document.getElementById('decrease-font').addEventListener('click', () => {
    applyFontSizeChange(-accessibilityOptions.fontSizeStep); // Zmniejsz czcionkę o zadany krok
    saveAccessibilitySettings(); // Zapisz zmienione ustawienie czcionki
  });

  // Obsługa trybu czarno-białego
  document.getElementById('black-white-mode').addEventListener('click', () => {
    if (document.body.classList.contains('black-white')) {
      document.body.classList.remove('black-white'); // Jeśli tryb czarno-biały jest aktywny, wyłącz go
    } else {
      document.body.classList.add('black-white'); // Jeśli tryb czarno-biały nie jest aktywny, włącz go
      document.body.classList.remove('high-contrast'); // Usuń tryb wysokiego kontrastu, jeśli włączony
    }
    saveAccessibilitySettings(); // Zapisz zmieniony tryb
  });

  // Obsługa trybu wysokiego kontrastu
  /*
  document
    .getElementById('high-contrast-mode')
    .addEventListener('click', () => {
      if (document.body.classList.contains('high-contrast')) {
        document.body.classList.remove('high-contrast'); // Jeśli tryb wysokiego kontrastu jest aktywny, wyłącz go
      } else {
        document.body.classList.add('high-contrast'); // Jeśli tryb wysokiego kontrastu nie jest aktywny, włącz go
        document.body.classList.remove('black-white'); // Usuń tryb czarno-biały, jeśli włączony
      }
      saveAccessibilitySettings(); // Zapisz zmieniony tryb
    });
  */

  // Resetowanie ustawień
  document.getElementById('reset-settings').addEventListener('click', () => {
    setBaseFontSize(62.5); // Resetowanie do wartości domyślnej (62.5%)
    document.body.classList.remove('black-white', 'high-contrast'); // Resetowanie trybu
    saveAccessibilitySettings(); // Zapisz domyślne ustawienia
  });

  // Funkcja do zapisywania ustawień dostępności w sesji
  function saveAccessibilitySettings() {
    fetch('/accessibility/saveSettings', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        fontSize: getBaseFontSize(),
        mode: document.body.classList.contains('black-white')
          ? 'black-white'
          : document.body.classList.contains('high-contrast')
            ? 'high-contrast'
            : 'default',
      }),
    }).catch(error =>
      console.error('Błąd podczas zapisywania ustawień:', error)
    );
  }

  // Zastosowanie nowych ustawień (jeśli są zapisane)
  function applySettings() {
    // Zastosuj rozmiar czcionki
    setBaseFontSize(getBaseFontSize());

    // Zastosuj tryb wyświetlania
    document.body.classList.remove('black-white', 'high-contrast');
    if (document.body.classList.contains('black-white')) {
      document.body.classList.add('black-white');
    } else if (document.body.classList.contains('high-contrast')) {
      document.body.classList.add('high-contrast');
    }

    // Zapisz ustawienia
    saveAccessibilitySettings();
  }
}